<script>  
  export let id;
  export let label;  
  export let value;
  export let type = "text";
  export let valid = "";
  export let validityMessage = "";
  export let disableRequiredAsterisk = false;
  export let comment = "";
  export let onKeyUp = "";
  export let placeholder = "";
</script>

<style>
  input,  
  input:focus,  

  label {
    display: block;
    margin-bottom: 0.5rem;
    width: 100%;
  }
  .form-control {
    padding: 0.5rem 0;
    width: 100%;
    margin: 0.25rem 0;
  }
  .error-message {
    color: red;
    margin: 0.25rem 0;
  }
  .required::after {
    color: red;
    content: " *";
  }
</style>

<div class="form-control">
  {#if validityMessage && !disableRequiredAsterisk}
    <label for={id} class="required">
      <strong>{label}</strong>
    </label>
  {:else}
    <label for={id}>
      <strong>{label}</strong>
    </label>
  {/if}
  {#if comment}
    <span style="color:blue">
      <small>
        <i>{comment}</i>
      </small>
    </span>
  {/if}  
  {#if onKeyUp}
    <div class="field">
      <div class="control">
        <input
          class="input is-primary"
          {type}
          {id}
          {value}
          placeholder={comment}
          on:keyup={() => onKeyUp}
          on:input />
      </div>
    </div>
  {:else}
    <div class="field">
      <div class="control">
        <input class="input" {type} {id} {value} on:input placeholder={placeholder} />
      </div>
    </div>
  {/if}
  {#if validityMessage && valid}
    <p class="error-message">{validityMessage}</p>
  {/if}
</div>
